module.exports = __webpack_public_path__ + "db7b627f90e1e78965554af2ba6a55a3.svg";